import TeachingBanner from "../components/Program-Teaching/Teaching.Banner";
import Section5 from "../components/Program-Teaching/Section5";

const TeachingPage = () => {
  return (
    <>
      <TeachingBanner />
      <Section5 />
    </>
  );
};

export default TeachingPage;
